<template>
	<div class="official-recommend-page">
		<div class="content-container">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<router-link to="/" class="breadcrumb-item">首页</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">猜你喜欢</span>
			</div>
			<div class="officialList">
				<OfficalItem class="officalItem" v-for="(item,index) in 8" :key="index"></OfficalItem>
			</div>

			<!-- 分页控件 -->
			<PagePagination :currentPage="currentPage" :total="total" @current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	import OfficalItem from '../components/OfficalItem.vue'
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'GuessLike',
		components: {
			OfficalItem,
			PagePagination
		},
		data() {
			return {
				currentPage: 1, // 当前页码
				total: 1000, // 总条数
				artworks: [{
						id: 1,
						title: '山水意境',
						artist: '东方水墨',
						image: 'https://picsum.photos/id/1/600/400',
						views: 3200,
						likes: 850
					},
					{
						id: 2,
						title: '深海传说',
						artist: '海洋之心',
						image: 'https://picsum.photos/id/137/600/400',
						views: 2800,
						likes: 780
					},
					{
						id: 3,
						title: '都市肖像',
						artist: '城市之光',
						image: 'https://picsum.photos/id/1015/600/400',
						views: 4100,
						likes: 920
					},
					{
						id: 4,
						title: '自然奇观',
						artist: '山水之间',
						image: 'https://picsum.photos/id/1024/600/400',
						views: 3500,
						likes: 890
					},
					{
						id: 5,
						title: '古韵今风',
						artist: '建筑大师',
						image: 'https://picsum.photos/id/1043/600/400',
						views: 2900,
						likes: 750
					},
					{
						id: 6,
						title: '未来城市',
						artist: '科技先锋',
						image: 'https://picsum.photos/id/1067/600/400',
						views: 3800,
						likes: 910
					}
				]
			}
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				// 这里添加实际的数据加载逻辑
				console.log(`切换到第${newPage}页`)
			},
		},
		mounted() {
			console.log('官方推荐页面已加载')
		}
	}
</script>

<style scoped>
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.officialList {
		width: 12rem;
		display: flex;
		flex-wrap: wrap;

		.officalItem:nth-child(4n) {
			margin-right: 0;
		}
	}
</style>